var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#115EA3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.175651 8.57613C-0.0586284 8.81052 -0.0585388 9.19046 0.175851 9.42473C0.41024 9.65901 0.790172 9.65892 1.02445 9.42453L4.72925 5.72013C4.74801 5.70133 4.77349 5.69076 4.80005 5.69076C4.82662 5.69076 4.85209 5.70133 4.87085 5.72013L8.57565 9.42533C8.7272 9.57696 8.94813 9.63621 9.15522 9.58078C9.3623 9.52534 9.52409 9.36364 9.57962 9.15658C9.63515 8.94952 9.576 8.72856 9.42445 8.57693L5.72005 4.87093C5.70124 4.85217 5.69067 4.8267 5.69067 4.80013C5.69067 4.77357 5.70124 4.7481 5.72005 4.72933L9.42525 1.02453C9.65953 0.789923 9.65926 0.409813 9.42465 0.175534C9.19004 -0.0587454 8.80993 -0.0584768 8.57565 0.176134L4.87085 3.88013C4.85209 3.89894 4.82662 3.90951 4.80005 3.90951C4.77349 3.90951 4.74801 3.89894 4.72925 3.88013L1.02445 0.176134C0.790172 -0.0582559 0.41024 -0.0583454 0.175851 0.175934C-0.0585388 0.410213 -0.0586284 0.790144 0.175651 1.02453L3.88005 4.72933C3.89886 4.7481 3.90943 4.77357 3.90943 4.80013C3.90943 4.8267 3.89886 4.85217 3.88005 4.87093L0.175651 8.57613Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.ea90fd7be98ab24725e829a30cc63fe1.svg";
export { ForwardRef as ReactComponent };